if (!customElements.get('product-variants-bundle-tk')) {
  customElements.define('product-variants-bundle-tk', class ProductVariantsBundleTk extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        single: this.querySelector('.section-product-info-tk__description__order__bundle__single'),
        bundle: this.querySelector('.section-product-info-tk__description__order__bundle__bundle'),
        productVariantSelector: document.querySelector('.section-product-info-tk__description__order__options')
      }
      this.isBundleActive = false;

      this.elements.single.addEventListener('click', this.onClickSingle.bind(this));
      this.elements.bundle.addEventListener('click', this.onClickBundle.bind(this));
      this.elements.productVariantSelector.classList.add('hidden');

      // Auto select the bundling option on page load
      document.addEventListener('DOMContentLoaded', () => {
        // console.log('DOMContentLoaded');
        this.onClickBundle();
      });
    }

      onClickSingle() {
        this.elements.bundle.classList.remove('active');
        this.elements.single.classList.add('active');
        this.isBundleActive = false;
        setTimeout(function () {
          window.refreshSplideInstances(1);
        }, 100)
        const productInfoTkOrderOptions = this.elements.single.querySelector('.section-product-info-tk__description__order__options');
        if (productInfoTkOrderOptions) {
          // console.log('found', this.elements.single.querySelector('.section-product-info-tk__description__order__options'));
          this.appendProductVariantSelector(productInfoTkOrderOptions);
        } else {
          console.log('not found', productInfoTkOrderOptions);
        }
      }

      onClickBundle() {
        this.elements.single.classList.remove('active');
        this.elements.bundle.classList.add('active');
        this.isBundleActive = true;
        setTimeout(function () {
          window.refreshSplideInstances(0);
        }, 100)
        const productInfoTkOrderOptions = this.elements.bundle.querySelector('.section-product-info-tk__description__order__options');
        if (productInfoTkOrderOptions) {
          // console.log('found', this.elements.bundle.querySelector('.section-product-info-tk__description__order__options'));
          this.appendProductVariantSelector(productInfoTkOrderOptions);
        } else {
          console.log('not found', productInfoTkOrderOptions);
        }
      }

      appendProductVariantSelector(el) {
        el.appendChild(this.elements.productVariantSelector);
        this.elements.productVariantSelector.classList.remove('hidden');
      }
  });
};